import { render, staticRenderFns } from "./PreprintList.vue?vue&type=template&id=2eee880c&scoped=true&"
import script from "./PreprintList.vue?vue&type=script&lang=js&"
export * from "./PreprintList.vue?vue&type=script&lang=js&"
import style0 from "./PreprintList.vue?vue&type=style&index=0&id=2eee880c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eee880c",
  null
  
)

export default component.exports